module.exports = __webpack_public_path__ + "img/header-image.dfa65cf.svg";